import { observable } from "mobx"

import { Lifetime } from "@/lib/Lifetime.ts"
import { getLogger } from "@/lib/logging.ts"

import type { Lifetimed } from "@/lib/Lifetime.ts"
import type { IObservableValue } from "mobx"


const log = getLogger("Model")

export class Model implements Lifetimed {
  readonly lifetime: Lifetime

  readonly isLoading: IObservableValue<boolean>

  constructor(readonly debugName: string) {
    this.lifetime = new Lifetime()
    this.isLoading = observable.box(false)
    log.debug(`Creating model ${this.debugName}`)
  }

  terminate() {
    if (this.lifetime.terminated) {
      log.debug(`Already terminated ${this.debugName}`)
      return
    }

    log.debug(`Terminating lifetime in ${this.debugName}`)

    this.lifetime.terminate()
  }
}
